import { Badge } from '@chakra-ui/react'

const STATUS_STYLES = {
  accepted: { bg: 'var(--mc-green-bg)', color: 'var(--mc-green)' },
  rejected: { bg: 'var(--mc-red-bg)', color: 'var(--mc-red)' },
  pending: { bg: 'var(--mc-amber-bg)', color: 'var(--mc-amber)' },
  redeemed: { bg: 'var(--mc-green-bg)', color: 'var(--mc-green)' },
  active: { bg: 'var(--mc-info-bg)', color: 'var(--mc-info)' },
}

export function StatusBadge({ status, label, ...props }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.pending
  const displayLabel = label || status

  return (
    <Badge bg={style.bg} color={style.color} fontSize="xs" {...props}>
      {displayLabel}
    </Badge>
  )
}
